import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import "moment/locale/tr";

export default class FloatingWhatsApp extends Component {
  state = {
    isVisible: false,
    showMessage: false,
    hasNotification: false,
    isCartOpen: false,
  };

  constructor(props) {
    super(props);
    this.whatsappRef = React.createRef();
  }

  componentDidMount() {
    // Step 1: Show WhatsApp button (2 seconds after load)
    setTimeout(() => {
      this.setState({ isVisible: true });
    }, 2000);

    // Step 2: Show notification badge (4 seconds after load)
    setTimeout(() => {
      this.setState({ hasNotification: true });
    }, 4000);

    // Step 3: Show message bubble (5 seconds after load)
    setTimeout(() => {
      this.setState({ showMessage: true });
    }, 5000);

    // Step 4: Hide message after 8 seconds
    setTimeout(() => {
      this.setState({ showMessage: false });
    }, 13000);

    // Cart listener
    this.setupCartListener();
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    document.body.classList.remove('cart-open');
  }

  setupCartListener = () => {
    this.observer = new MutationObserver(() => {
      const isCartOpen = document.body.classList.contains('cart-open');
      if (isCartOpen !== this.state.isCartOpen) {
        this.setState({ isCartOpen });
      }
    });

    this.observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  };

  handleWhatsAppClick = () => {
    this.setState({ hasNotification: false, showMessage: false });
  };

  handleMouseEnter = () => {
    if (this.state.hasNotification || this.state.showMessage) {
      this.setState({ showMessage: true });
    }
  };

  handleMouseLeave = () => {
    setTimeout(() => {
      this.setState({ showMessage: false });
    }, 2000);
  };

  // Telefon numarasını WhatsApp formatına çevir
  formatPhoneNumber = (phone) => {
    if (!phone) return '';

    // Tüm boşlukları, tireleri, parantezleri ve özel karakterleri temizle
    let cleanNumber = phone.replace(/[\s\-\(\)\+]/g, '');

    // Eğer numaranın başında 0 varsa, Türkiye ülke kodu ile değiştir
    if (cleanNumber.startsWith('0')) {
      cleanNumber = '90' + cleanNumber.substring(1);
    }

    // Eğer başında 90 yoksa, ekle (Türkiye için)
    if (!cleanNumber.startsWith('90')) {
      cleanNumber = '90' + cleanNumber;
    }

    return cleanNumber;
  };

  render() {
    const { isVisible, showMessage, hasNotification, isCartOpen } = this.state;
    const { phoneNumber, title, content } = this.props;

    // Telefon numarasını formatla
    const formattedPhone = this.formatPhoneNumber(phoneNumber);
    const whatsappUrl = `https://wa.me/${formattedPhone}`;
    const currentTime = moment().format("HH:mm");

    if (!isVisible) {
      return null;
    }

    const containerStyle = {
      zIndex: isCartOpen ? 900 : 999,
    };

    return (
      <div 
        className="floating-whatsapp-horizontal" 
        style={containerStyle}
        ref={this.whatsappRef}
      >
        {/* Horizontal Layout Container */}
        <div className="whatsapp-horizontal-container">
          
          {/* Message Bubble - Left Side */}
          <div className={`whatsapp-message-horizontal ${showMessage ? 'show' : ''}`}>
            <div className="message-bubble-horizontal">
              <div className="message-header-horizontal">
                <span className="sender-name-horizontal">
                  {title || "Botaniksan"}
                </span>
                <span className="message-time-horizontal">{currentTime}</span>
              </div>
              <div className="message-content-horizontal">
                {content || "WhatsApp üzerinden bize ulaşmak için tıklayın! 💬"}
              </div>
              <div className="message-tail-horizontal"></div>
            </div>
          </div>

          {/* WhatsApp Button - Right Side */}
          <a 
            href={whatsappUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="whatsapp-button-horizontal"
            onClick={this.handleWhatsAppClick}
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
            title="WhatsApp ile iletişime geç"
          >
            <div className="button-content-horizontal">
              
              {/* Notification Badge */}
              {hasNotification && (
                <span className="notification-badge-horizontal">
                  1
                </span>
              )}

              <FontAwesomeIcon 
                icon={["fab", "whatsapp"]} 
                className="whatsapp-icon-horizontal"
              />

              {/* Ripple Effect */}
              <div className="ripple-effect-horizontal"></div>
            </div>
          </a>

        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/FloatingWhatsApp.js